import { CachedRequest } from './base/cachedRequest'
import { endpoint } from './endpoints/def'

export const instance = new CachedRequest(1000 * 3)

export async function apiLogout() {
  return instance.get(endpoint.logout)
}

